import ModalCancelOrder from 'components/ModalCancelOrder/styled';

export default ModalCancelOrder;
